/* eslint-disable id-length */
import { coerce, rcompare } from 'semver';

function rcompareVersions(versionA: string, versionB: string) {
  const semVerA = coerce(versionA);
  const semVerB = coerce(versionB);

  if (semVerA && semVerB) {
    return rcompare(semVerA, semVerB);
  }

  // NOTE: Satisfy reflexivity requirement
  if (versionA === versionB) {
    return 0;
  }

  if (!semVerA) {
    // NOTE: Bubble up 'dev' and 'beta'
    if (versionA === 'dev' || (versionA === 'beta' && versionB !== 'dev')) {
      return -1;
    }
    // NOTE: Bubble down everything else
    return 1;
  }
  if (!semVerB) {
    // NOTE: Bubble up 'dev' and 'beta'
    if (versionB === 'dev' || (versionB === 'beta' && versionA !== 'dev')) {
      return 1;
    }
    // NOTE: Bubble down everything else
    return -1;
  }
  return 0;
}

function caseInsensitiveCompare(a: string, b: string) {
  const upperA = a.toUpperCase();
  const upperB = b.toUpperCase();

  if (upperA < upperB) {
    return -1;
  }
  if (upperA > upperB) {
    return 1;
  }
  return 0;
}

export const compare = {
  /**
   * Comparison function defining a descending sort order for semver strings.
   *
   * Arguments that cannot be coerced into a semver sink to the bottom
   * **except** for 'dev' and 'beta' which will bubble to the top, in that order.
   */
  rsemver: rcompareVersions,
  /**
   * Comparison function defining an ascending sort order for strings, ignoring
   * case sensitivity.
   * e.g. apple, Banana, Carrot, daikon instead of Banana, Carrot, apple, daikon
   */
  caseInsensitiveStrings: caseInsensitiveCompare,
};
